import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  FirstCabinGuests,
  OccupancyState,
  SecondCabinGuests,
} from '../../../../../interfaces/src/lib/types/index';
import { getSearchParams } from '../../utilFuncs/utilFuncs';

const initialState: OccupancyState = {
  occupancyFirstCabinGuests: {
    adults: 2,
    minor: 0,
    infants: 0,
    cabinAccessible: false,
  },
  occupancySecondCabinGuests: {
    adults: 2,
    minor: 0,
    infants: 0,
    cabinAccessible: false,
    requestConnectedCabin: false,
    needed: false,
  },
};

const resetOccupancyState = (state: OccupancyState) => {
  const searchParams = new URLSearchParams(window.location.search);
  const { isDeal, adultsOccupancy, childrenOccupancy, infantOccupancy, cabinAccessible } =
    getSearchParams(searchParams);
  if (isDeal) {
    state.occupancyFirstCabinGuests = {
      adults: Number(adultsOccupancy),
      minor: Number(childrenOccupancy),
      infants: Number(infantOccupancy),
      cabinAccessible: cabinAccessible || false,
    };
  }
  return state;
};

const occupancySlice = createSlice({
  name: 'occupancy',
  initialState,
  reducers: {
    setOccupancyFirstCabinGuests: (state, action: PayloadAction<FirstCabinGuests>) => {
      state.occupancyFirstCabinGuests = action.payload;
    },
    setOccupancySecondCabinGuests: (state, action: PayloadAction<SecondCabinGuests>) => {
      state.occupancySecondCabinGuests = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase('resetFromPriceType', resetOccupancyState)
      .addCase('resetFromOccupancy', resetOccupancyState),
});

export const { setOccupancyFirstCabinGuests, setOccupancySecondCabinGuests } =
  occupancySlice.actions;
export default occupancySlice.reducer;
